import script from "./ExportJSON.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExportJSON.vue?vue&type=script&lang=ts&setup=true"

import "./ExportJSON.vue?vue&type=style&index=0&id=0cc0995e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cc0995e"]])

export default __exports__